import { useMemo } from "react";
import { useController, useFormContext } from "react-hook-form";
import { keyBy } from "lodash";

export const FIELD_TYPE = {
  STREAM_AND_TAG: "Client Streams & Tags",
  THIS_WORKFLOW: "This Workflow",
  FORM_FIELD: "Form Field",
};

function getDefaultValue(type, parameters) {
  switch (type) {
    case FIELD_TYPE.STREAM_AND_TAG:
      return {
        value: null,
        streams: [],
        tags: [],
        operand: parameters[0].operands[0],
      };
    default:
      return null;
  }
}

export function useConditionController(condition, conditionTypes) {
  const typesNamesMap = useMemo(() => {
    return keyBy(conditionTypes, "name");
  }, [conditionTypes]);

  const { field } = useController({
    name: `${condition.id}.type`,
    defaultValue: {
      name: condition.name || null,
      id: typesNamesMap[condition.name]?.type || null,
    },
    rules: {
      validate: ({ name: n, id: i }) => {
        return Boolean(n && i);
      },
      required: { value: true, message: "Please select condition type" },
    },
  });

  const { resetField } = useFormContext();
  return {
    parameters: typesNamesMap[field.value.name]?.parameters,
    conditionType: field.value.id,
    conditionProps: {
      value: field.value.name,
      options: Object.keys(typesNamesMap),
      onChange: (_, t) => {
        resetField(`${condition.id}.condition`, {
          defaultValue: getDefaultValue(
            typesNamesMap[t].type,
            typesNamesMap[t].parameters
          ),
        });

        field.onChange({ name: t, id: typesNamesMap[t].type });
      },
    },
  };
}

export default useConditionController;
